var _defs, _path, _path2, _g, _g2, _g3, _g4, _g5, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerDataEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500.099,
    height: 286.417,
    viewBox: "0 0 500.099 286.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_487",
    "data-name": "Ellipse 487",
    cx: 34.085,
    cy: 34.085,
    r: 34.085,
    transform: "translate(0 48.204) rotate(-45)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.412,
    y1: -0.83,
    x2: 0.577,
    y2: 2.157,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4421b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c0e16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.411,
    y1: 1.081,
    x2: 0.548,
    y2: -0.237,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.208,
    y1: 2.478,
    x2: 0.81,
    y2: -1.626,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.217,
    y1: 2.299,
    x2: 0.887,
    y2: -1.819,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_494",
    "data-name": "Ellipse 494",
    cx: 35.292,
    cy: 35.292,
    r: 35.292,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -95.652,
    y1: 9.148,
    x2: -96.137,
    y2: 12.288,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.348,
    y1: 1.13,
    x2: 0.81,
    y2: -0.923,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -37.142,
    y1: -1.71,
    x2: -37.36,
    y2: 1.264,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    y1: -2.249,
    x2: 0.5,
    y2: -0.887,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.5,
    y1: -3.378,
    x2: 0.5,
    y2: -1.543,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    y1: -3.431,
    x2: 0.5,
    y2: -1.574,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_497",
    "data-name": "Ellipse 497",
    cx: 31.749,
    cy: 31.749,
    r: 31.749,
    transform: "translate(0 44.9) rotate(-45)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 3.718,
    y1: -6.769,
    x2: 2.681,
    y2: -4.39,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1.015,
    y1: -2.003,
    x2: 0.213,
    y2: 2.486,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.437,
    y1: 0.528,
    x2: 0.859,
    y2: -1.058,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.332,
    y1: 0.915,
    x2: 2.249,
    y2: -4.024,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.544,
    y1: 0.447,
    x2: 2.68,
    y2: -4.509,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.563,
    y1: 0.178,
    x2: 0.341,
    y2: 1.734,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.573,
    y1: 0.208,
    x2: 0.332,
    y2: 1.663,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507",
    "data-name": "Ellipse 507",
    cx: 31.233,
    cy: 31.233,
    r: 31.233,
    transform: "translate(556.832 348.447)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.755,
    y1: 0.195,
    x2: 4.508,
    y2: -4.313,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.037,
    y1: 1.034,
    x2: 3.384,
    y2: -4.028,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.375,
    y1: 0.718,
    x2: 0.716,
    y2: -0.122,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0.447,
    y1: 0.532,
    x2: 1.074,
    y2: -0.751,
    xlinkHref: "#linear-gradient-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5652",
    "data-name": "Group 5652",
    transform: "translate(-764.999 -356.424)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6147",
    "data-name": "Path 6147",
    d: "M291.683,229.806C350.61,207.93,410.5,227.271,451.122,269.4S576.989,240.32,622.2,282.376c30.854,28.7,16.722,102.493-25.585,134.454-57.5,43.442-232.381,21.4-270.209,14.006-43.582-8.517-75.443-34.359-88.389-65.724C206.825,289.538,265.642,239.474,291.683,229.806Z",
    transform: "translate(587.936 188.558)",
    fill: "#dde4eb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6151",
    "data-name": "Path 6151",
    d: "M918.844,1703.293c-38.975-1.7-171.561,1.182-211.885,2.307s-87.13-1.484-111.444-5.321-164.854.326-158.476,10.643,62.617,4.615,126.394,8.761,207.212-.518,239.566,0,62.023-1.036,103.718-3.11S941.436,1704.281,918.844,1703.293Z",
    transform: "translate(328.17 -1078.576)",
    fill: "#dde4eb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5583",
    "data-name": "Group 5583",
    transform: "translate(312 128.585)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_504",
    "data-name": "Ellipse 504",
    cx: 20.515,
    cy: 20.515,
    r: 20.515,
    transform: "translate(741.063 292.184)",
    fill: "#f2a35b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_505",
    "data-name": "Ellipse 505",
    cx: 19.833,
    cy: 19.833,
    r: 19.833,
    transform: "translate(741.745 292.866)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6397",
    "data-name": "Path 6397",
    d: "M1226.528,1488.909h-.01a.188.188,0,0,1-.178-.2,18.645,18.645,0,0,1,.269-2.323.188.188,0,0,1,.37.067,18.225,18.225,0,0,0-.263,2.276A.188.188,0,0,1,1226.528,1488.909Z",
    transform: "translate(-483.234 -1176.994)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6398",
    "data-name": "Path 6398",
    d: "M1239.724,1393.795a.185.185,0,0,1-.085-.02.188.188,0,0,1-.083-.252,18.418,18.418,0,0,1,16.521-10.172,18.674,18.674,0,0,1,3.336.3.188.188,0,1,1-.067.369,18.284,18.284,0,0,0-3.269-.294,18.045,18.045,0,0,0-16.186,9.966A.187.187,0,0,1,1239.724,1393.795Z",
    transform: "translate(-494.501 -1089.147)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_506",
    "data-name": "Ellipse 506",
    cx: 16.786,
    cy: 16.786,
    r: 16.786,
    transform: "translate(745.224 296.345)",
    fill: "#fff",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6399",
    "data-name": "Path 6399",
    d: "M1330.706,1441.073c0,2.842-2.3,5.911-5.146,5.911s-5.146-3.068-5.146-5.911a5.155,5.155,0,0,1,10.293,0Z",
    transform: "translate(-563.557 -1134.285)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6400",
    "data-name": "Path 6400",
    d: "M1291.113,1530.431h12.563a3.041,3.041,0,0,0,2.9-2.114l.676-2.113a3.038,3.038,0,0,0-1.835-3.78c-5.113-1.869-10.4-1.63-15.815.172a3.028,3.028,0,0,0-1.941,3.671l.521,1.919A3.041,3.041,0,0,0,1291.113,1530.431Z",
    transform: "translate(-535.498 -1206.789)",
    fill: "#fcb151"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5584",
    "data-name": "Group 5584",
    transform: "translate(376.184 154.226)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_504-2",
    "data-name": "Ellipse 504",
    cx: 13.194,
    cy: 13.194,
    r: 13.194,
    transform: "translate(741.063 292.184)",
    fill: "#f2a35b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_505-2",
    "data-name": "Ellipse 505",
    cx: 12.756,
    cy: 12.756,
    r: 12.756,
    transform: "translate(741.502 292.623)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6397-2",
    "data-name": "Path 6397",
    d: "M1226.461,1487.954h-.006a.121.121,0,0,1-.114-.127,11.994,11.994,0,0,1,.173-1.494.121.121,0,0,1,.238.043,11.7,11.7,0,0,0-.169,1.464A.121.121,0,0,1,1226.461,1487.954Z",
    transform: "translate(-483.963 -1183.08)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6398-2",
    "data-name": "Path 6398",
    d: "M1239.657,1390.068a.121.121,0,0,1-.108-.175,11.846,11.846,0,0,1,10.626-6.543,12,12,0,0,1,2.146.193.121.121,0,1,1-.043.237,11.753,11.753,0,0,0-2.1-.189,11.606,11.606,0,0,0-10.41,6.41A.12.12,0,0,1,1239.657,1390.068Z",
    transform: "translate(-495.918 -1089.867)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_506-2",
    "data-name": "Ellipse 506",
    cx: 10.796,
    cy: 10.796,
    r: 10.796,
    transform: "translate(743.739 294.86)",
    fill: "#fff",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6399-2",
    "data-name": "Path 6399",
    d: "M1327.033,1439.339c0,1.828-1.482,3.8-3.31,3.8s-3.31-1.973-3.31-3.8a3.315,3.315,0,0,1,6.62,0Z",
    transform: "translate(-569.193 -1137.762)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6400-2",
    "data-name": "Path 6400",
    d: "M1289.842,1527.112h8.08a1.956,1.956,0,0,0,1.863-1.36l.435-1.359a1.954,1.954,0,0,0-1.18-2.431,15.06,15.06,0,0,0-10.172.111,1.948,1.948,0,0,0-1.248,2.361l.335,1.234A1.956,1.956,0,0,0,1289.842,1527.112Z",
    transform: "translate(-539.419 -1214.696)",
    fill: "#fcb151"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5585",
    "data-name": "Group 5585",
    transform: "translate(324.506 204.954)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_504-3",
    "data-name": "Ellipse 504",
    cx: 11.413,
    cy: 11.413,
    r: 11.413,
    transform: "translate(741.063 292.184)",
    fill: "#f2a35b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_505-3",
    "data-name": "Ellipse 505",
    cx: 11.034,
    cy: 11.034,
    r: 11.034,
    transform: "translate(741.442 292.563)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6397-3",
    "data-name": "Path 6397",
    d: "M1226.445,1487.722h-.006a.1.1,0,0,1-.1-.11,10.377,10.377,0,0,1,.149-1.292.1.1,0,0,1,.206.037,10.1,10.1,0,0,0-.146,1.266A.1.1,0,0,1,1226.445,1487.722Z",
    transform: "translate(-484.14 -1184.561)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6398-3",
    "data-name": "Path 6398",
    d: "M1239.64,1389.161a.1.1,0,0,1-.093-.151,10.247,10.247,0,0,1,9.192-5.66,10.382,10.382,0,0,1,1.856.167.1.1,0,1,1-.037.205,10.168,10.168,0,0,0-1.819-.164,10.039,10.039,0,0,0-9.005,5.545A.1.1,0,0,1,1239.64,1389.161Z",
    transform: "translate(-496.263 -1090.043)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_506-3",
    "data-name": "Ellipse 506",
    cx: 9.339,
    cy: 9.339,
    r: 9.339,
    transform: "translate(743.378 294.499)",
    fill: "#fff",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6399-3",
    "data-name": "Path 6399",
    d: "M1326.139,1438.917c0,1.581-1.282,3.288-2.863,3.288s-2.863-1.707-2.863-3.288a2.868,2.868,0,0,1,5.727,0Z",
    transform: "translate(-570.564 -1138.608)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6400-3",
    "data-name": "Path 6400",
    d: "M1289.532,1526.3h6.99a1.692,1.692,0,0,0,1.611-1.176l.376-1.175a1.69,1.69,0,0,0-1.021-2.1,13.026,13.026,0,0,0-8.8.1,1.685,1.685,0,0,0-1.08,2.042l.29,1.068A1.692,1.692,0,0,0,1289.532,1526.3Z",
    transform: "translate(-540.373 -1216.619)",
    fill: "#fcb151"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5581",
    "data-name": "Group 5581",
    transform: "translate(776.027 504.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6418",
    "data-name": "Path 6418",
    d: "M1949.891,2324.483a1.352,1.352,0,0,1-.945-.466c-3.5-4.041-29.107-35.8-.677-68.724,26.989-31.257,39.764-38.219,40.239-55.427a2.009,2.009,0,0,1,3.738-.96c7.639,12.937,20.324,43.513-12.307,66.661-36,25.535-31.035,50.186-28.68,57.12a1.358,1.358,0,0,1-1.367,1.8Z",
    transform: "translate(-1935.012 -2197.917)",
    fill: "#63e8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6419",
    "data-name": "Path 6419",
    d: "M2074.754,2943.778a1.956,1.956,0,0,1-1.793-1.509c-1.338-5.756-5.185-27.354,10.415-34.33,17.173-7.68,32.658,7.686,44.665-6.156a.987.987,0,0,1,1.732.735c-.65,6.808-4.623,22.761-27.271,27.614-24.242,5.194-26.787,8.211-26.031,11.66a1.648,1.648,0,0,1-1.717,1.985Z",
    transform: "translate(-2055.152 -2816.927)",
    fill: "#24dcae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6420",
    "data-name": "Path 6420",
    d: "M2020.529,2355.9a25.2,25.2,0,0,1-.9,3.724,36.9,36.9,0,0,1-1.329,3.572,45.431,45.431,0,0,1-3.589,6.732,53.415,53.415,0,0,1-10.062,11.462,69.69,69.69,0,0,1-6.062,4.611,58.124,58.124,0,0,0-5.745,4.507,63.936,63.936,0,0,0-9.715,10.907,54.485,54.485,0,0,0-10.025,27.115,51.135,51.135,0,0,0,1.015,14.6,60.511,60.511,0,0,0,4.934,13.912.479.479,0,0,1-.846.448,57.3,57.3,0,0,1-5.691-13.981,49.846,49.846,0,0,1-1.568-15.11,52.152,52.152,0,0,1,2.987-14.953,59.189,59.189,0,0,1,6.971-13.571,63.836,63.836,0,0,1,10.078-11.451,60.9,60.9,0,0,1,6-4.746,70.005,70.005,0,0,0,5.886-4.386,58.772,58.772,0,0,0,10.013-10.613,51.368,51.368,0,0,0,3.907-6.2,38.757,38.757,0,0,0,2.877-6.739l.009-.03a.437.437,0,0,1,.85.195Z",
    transform: "translate(-1966.578 -2336.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6421",
    "data-name": "Path 6421",
    d: "M2084.9,2973.389a1.548,1.548,0,0,0,0-.612l-.064-.6-.1-1.2q-.088-1.2-.127-2.4c-.049-1.6-.033-3.21.061-4.814a35.941,35.941,0,0,1,1.735-9.494,17.041,17.041,0,0,1,5.391-8.079,13.191,13.191,0,0,1,4.428-2.223,16.787,16.787,0,0,1,4.89-.618c6.432.26,12.773,1.013,19.114,1.534a33.446,33.446,0,0,0,9.385-.241,13.943,13.943,0,0,0,2.2-.681,11.847,11.847,0,0,0,2.021-1.092,14.808,14.808,0,0,0,3.329-3.222l0,0a.39.39,0,0,1,.62.472,15.625,15.625,0,0,1-3.45,3.479,12.742,12.742,0,0,1-2.157,1.225,14.869,14.869,0,0,1-2.349.782,34.307,34.307,0,0,1-9.683.365c-3.2-.213-6.37-.564-9.546-.836s-6.367-.528-9.509-.659a15.689,15.689,0,0,0-4.577.535,12.125,12.125,0,0,0-4.094,2.009,16.105,16.105,0,0,0-5.208,7.543,35.175,35.175,0,0,0-1.862,9.252c-.122,1.58-.167,3.167-.148,4.754q.015,1.191.082,2.38l.081,1.187.052.592a1.293,1.293,0,0,0,.137.577.362.362,0,1,1-.657.1Z",
    transform: "translate(-2066.608 -2850.411)",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5582",
    "data-name": "Group 5582",
    transform: "translate(386.543 25.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_485",
    "data-name": "Ellipse 485",
    cx: 37.477,
    cy: 37.477,
    r: 37.477,
    transform: "translate(461.094 398.508) rotate(-45)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_486",
    "data-name": "Ellipse 486",
    cx: 34.085,
    cy: 34.085,
    r: 34.085,
    transform: "translate(465.535 398.619) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5558",
    "data-name": "Group 5558",
    transform: "translate(465.73 350.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5557",
    "data-name": "Group 5557",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5556",
    "data-name": "Group 5556",
    transform: "translate(15.982 15.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6344",
    "data-name": "Path 6344",
    d: "M2152.135,1036.883c.536-2.493.961-4.124.961-4.124l-9.474-16.046s-3.067,3.1-4.905,16.629a3.121,3.121,0,0,0,3.092,3.541Z",
    transform: "translate(-2138.688 -971.327)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6345",
    "data-name": "Path 6345",
    d: "M2453.613,1030.323c-2.631-11.726-7.314-17.185-7.314-17.185l-5.929,19.644s.179.388.453,1.136h9.914A2.949,2.949,0,0,0,2453.613,1030.323Z",
    transform: "translate(-2388.922 -968.362)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6346",
    "data-name": "Path 6346",
    d: "M2176.061,994.3c9.74,3.582,22.974,3.082,38.417,0a50.455,50.455,0,0,1,1.51-4.957l4.075-15.827c-5.712-5.121-13.74-6.812-16.829-7.292-7.177-1.78-15.567-.2-15.567-.2-11.374.794-20.047,8.093-20.047,8.093l7.048,16.039A32.692,32.692,0,0,1,2176.061,994.3Z",
    transform: "translate(-2162.687 -928.748)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6347",
    "data-name": "Path 6347",
    d: "M2292.534,923.818l-.242,7.994a1.815,1.815,0,0,0,1.212,1.766c2.044.721,6.275,1.817,10.285.381a1.809,1.809,0,0,0,1.171-1.968l-1.2-8.173Z",
    transform: "translate(-2266.096 -894.274)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5555",
    "data-name": "Group 5555",
    transform: "translate(19.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6348",
    "data-name": "Path 6348",
    d: "M2276.356,812.981s.47,10.8,2.348,15.026,6.574,4.226,7.043,4.226a10.745,10.745,0,0,0,7.043-4.7c2.348-3.757,3.287-15.965,3.287-15.965s-4.226-4.7-9.861-5.165S2276.356,810.633,2276.356,812.981Z",
    transform: "translate(-2272.842 -796.859)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6349",
    "data-name": "Path 6349",
    d: "M2375.326,856.424s2.155-3.232,3.232-2.155-1.077,8.081-3.232,8.081S2375.326,856.424,2375.326,856.424Z",
    transform: "translate(-2354.14 -836.403)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6350",
    "data-name": "Path 6350",
    d: "M2265.68,857.09s-2.694-3.771-3.771-2.694,1.616,8.081,3.771,8.081Z",
    transform: "translate(-2260.656 -836.531)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6351",
    "data-name": "Path 6351",
    d: "M2280.318,764.052c.013-.731-.028-1.486-.065-2.347a17.243,17.243,0,0,1,.135-2.577,3.734,3.734,0,0,0-4.645-3.8.893.893,0,0,1-.546.041c-.216-.085-.312-.331-.4-.547a6.484,6.484,0,0,0-7.045-4.2,7.591,7.591,0,0,0-5.925,4.3.751.751,0,0,1-.243.348.718.718,0,0,1-.378.075c-1.271.017-2.736-.262-3.809.52a3.866,3.866,0,0,0-1.64,2.837,7.327,7.327,0,0,0,1.018,3.559,2.816,2.816,0,0,1,.418,2.161,6.72,6.72,0,0,1-.323.616c-1.157,2.3,1.882,4.557,2.443,6.617l1.277,4.69a11.242,11.242,0,0,0,.159-3.036,35.392,35.392,0,0,1-.443-4.17,6.821,6.821,0,0,1,.732-2.9c.445-.861,1.257-1.241,1.864-2a3.839,3.839,0,0,0,1.933,1.183,3.245,3.245,0,0,0,1.424-.189c.7-.218,1.688-1.006,2.365-1.06s.911.656,1.357,1.031a5.062,5.062,0,0,0,4.844.709c-.345.144,1.67,3.9,1.736,4.244a40.513,40.513,0,0,1,.693,6.066c.161.118.342-.122.394-.314.366-1.356.48-2.766.716-4.15a29.952,29.952,0,0,1,1.41-4.535A9.935,9.935,0,0,0,2280.318,764.052Z",
    transform: "translate(-2255.752 -750.575)",
    fill: "#3a384d"
  }))))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488",
    "data-name": "Ellipse 488",
    cx: 34.341,
    cy: 34.341,
    r: 34.341,
    transform: "translate(539.826 379.578) rotate(-45)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_489",
    "data-name": "Ellipse 489",
    cx: 31.233,
    cy: 31.233,
    r: 31.233,
    transform: "translate(556.832 348.447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_491",
    "data-name": "Ellipse 491",
    cx: 38.804,
    cy: 38.804,
    r: 38.804,
    transform: "translate(490.818 443.18)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_492",
    "data-name": "Ellipse 492",
    cx: 35.292,
    cy: 35.292,
    r: 35.292,
    transform: "translate(493.961 446.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5567",
    "data-name": "Group 5567",
    transform: "translate(494.164 447.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5566",
    "data-name": "Group 5566",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5565",
    "data-name": "Group 5565",
    transform: "translate(10.664 1.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5564",
    "data-name": "Group 5564"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_493",
    "data-name": "Ellipse 493",
    cx: 11.511,
    cy: 11.511,
    r: 11.511,
    transform: "translate(9.121 18.249) rotate(-45)",
    fill: "#3a384d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6366",
    "data-name": "Path 6366",
    d: "M2319.412,1320.2c-5.063,17.508-8.505,33.423-7.947,37.9l14.76-1.558,1.711-32.383Z",
    transform: "translate(-2305.067 -1305.165)",
    fill: "#3a384d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6367",
    "data-name": "Path 6367",
    d: "M2444.31,1305.987l-2.026,39.585,16.7,8.894c-.35-13.528-7.261-48.289-10.09-49.222Z",
    transform: "translate(-2413.626 -1292.761)",
    fill: "#3a384d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6368",
    "data-name": "Path 6368",
    d: "M2402.485,1435.307l.486,10.781-10.456,1.574-.659-11.317Z",
    transform: "translate(-2371.798 -1400.642)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6369",
    "data-name": "Path 6369",
    d: "M2380.793,1327.581s-2.506,11.192-9.286,12.537-8.789-9.2-9.147-9.959c0,0-1.516.715-1.857-.792s-2.129-5.3,1.244-5.222c0,0-.664-3.765.5-5.613s3.519-6.294,8.365-5.058S2383.21,1318.787,2380.793,1327.581Z",
    transform: "translate(-2345.146 -1299.408)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6370",
    "data-name": "Path 6370",
    d: "M2368.005,1477.391l6.631,3.516-8.684,9.529-16.055-10.1c2.446-.913,4.85-2.14,7.047-2.505Z",
    transform: "translate(-2336.994 -1435.55)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6371",
    "data-name": "Path 6371",
    d: "M2368.019,1305.183c-2.266,3.169-.484,5.981-1.093,8.256,2.2-.8,9.607-1.99,11.838-1.771.461-1.516-.444-4.039-.908-6.027.724,1.888,2.378,4.779,2.2,6.27,3,.138,2.383.179,5.75,1.528l-2.622-9.141C2377.349,1301.571,2372.307,1301.918,2368.019,1305.183Z",
    transform: "translate(-2351.038 -1290.459)",
    fill: "#3a384d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6372",
    "data-name": "Path 6372",
    d: "M2404.62,1236.019c0,2.2-2.068,4.665-3.559,4.665-1.228,0-3.559-2.467-3.559-4.665a3.581,3.581,0,1,1,7.118,0Z",
    transform: "translate(-2376.481 -1232.039)",
    fill: "#3a384d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6373",
    "data-name": "Path 6373",
    d: "M2341.708,1504.8l3.651-20.308c-4.966-3.378-9.57-4.986-15.04-7.059-1.7,3.526-9.441,3.176-11.061.438a48.823,48.823,0,0,0-14.8,6.858l5,20.071Z",
    transform: "translate(-2299.308 -1435.585)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6374",
    "data-name": "Path 6374",
    d: "M2524.07,1535.545c-2.957-12.644-6.363-16.716-6.363-16.716l-5.462,16.622s.658,1.326,1.522,3.685h7.45A2.928,2.928,0,0,0,2524.07,1535.545Z",
    transform: "translate(-2471.656 -1469.921)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6375",
    "data-name": "Path 6375",
    d: "M2284.748,1540.314a48.2,48.2,0,0,1,2.458-6.784l-7.816-13.282a48.977,48.977,0,0,0-5.131,16.783,2.922,2.922,0,0,0,2.9,3.283Z",
    transform: "translate(-2274.236 -1471.098)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6376",
    "data-name": "Path 6376",
    d: "M2460.736,1314.385c3.873,9.792,5.808,37.412,3.441,52.019,3.7-12.751,8.315-28.925,1.268-50.673Z",
    transform: "translate(-2428.931 -1300.342)",
    fill: "#3a384d"
  }))))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_495",
    "data-name": "Ellipse 495",
    cx: 34.908,
    cy: 34.908,
    r: 34.908,
    transform: "translate(575.965 418.163)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_496",
    "data-name": "Ellipse 496",
    cx: 31.749,
    cy: 31.749,
    r: 31.749,
    transform: "translate(565.643 453.174) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5572",
    "data-name": "Group 5572",
    transform: "translate(565.824 408.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5571",
    "data-name": "Group 5571",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5570",
    "data-name": "Group 5570",
    transform: "translate(10.636 16.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6377",
    "data-name": "Path 6377",
    d: "M3005.476,1351.258a3.19,3.19,0,0,0,3.19-3.212c-.034-5.069-.137-9.523-.373-11.982-.6-6.275-3.933-8.266-3.933-8.266l-1.7,23.459Z",
    transform: "translate(-2950.075 -1287.944)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6378",
    "data-name": "Path 6378",
    d: "M2817.039,1332.914c-.248-13.142-.491-24.01-.491-24.01-5.951-3.662-27.923-3.2-27.923-3.2s-1.526,12.678-3.265,27.212Z",
    transform: "translate(-2769.83 -1269.6)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6379",
    "data-name": "Path 6379",
    d: "M2749.148,1320.135H2769.6c-.657-6.353-5.937-29.859-5.937-29.859l-16.4,5.019s1.3,14.655,1.3,19.233C2748.553,1315.576,2748.847,1317.611,2749.148,1320.135Z",
    transform: "translate(-2738.225 -1256.82)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6380",
    "data-name": "Path 6380",
    d: "M2705.829,1344.634c.073-7.746-.065-22.033-2.505-24.821,0,0-3.16,1.626-6.364,12.154-.925,3.038-1.765,5.923-2.547,8.671a3.138,3.138,0,0,0,3.019,4Z",
    transform: "translate(-2694.291 -1281.32)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6381",
    "data-name": "Path 6381",
    d: "M2911.089,1329.142c.59-11.14,1.105-23.011.616-23.5-.916-.916-11.915-4.506-11.915-4.506s-7.167,21.914-8.831,28.006Z",
    transform: "translate(-2857.42 -1265.828)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6382",
    "data-name": "Path 6382",
    d: "M2847.455,1266.316l2.747-9.613h10.07l1.373,10.986S2852.948,1269.978,2847.455,1266.316Z",
    transform: "translate(-2821.335 -1228.972)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5569",
    "data-name": "Group 5569",
    transform: "translate(23.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6383",
    "data-name": "Path 6383",
    d: "M2847.455,1156.272s.947,9.2,2.542,12.786,5.585,3.591,5.985,3.591a9.13,9.13,0,0,0,5.985-3.99c1.995-3.192,2.793-13.565,2.793-13.565s-3.591-3.99-8.379-4.389S2847.455,1154.277,2847.455,1156.272Z",
    transform: "translate(-2844.946 -1141.027)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6384",
    "data-name": "Path 6384",
    d: "M2934.759,1193.2s1.831-2.746,2.746-1.831-.915,6.866-2.746,6.866S2934.759,1193.2,2934.759,1193.2Z",
    transform: "translate(-2916.686 -1174.629)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6385",
    "data-name": "Path 6385",
    d: "M2841.593,1193.771s-2.289-3.2-3.2-2.289,1.373,6.866,3.2,6.866Z",
    transform: "translate(-2837.253 -1174.737)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6386",
    "data-name": "Path 6386",
    d: "M2855.511,1107.22a8.518,8.518,0,0,0,.453-4.009c-.237-2.032-1.33-5.8-2.842-7.314.43.43-3.674,2.166-4.306,2.1,1.233-1.005,2.769-2.154,2.824-3.907a12.409,12.409,0,0,1-4.865,1.609c-4.23.745-8.775.589-12.029,3.789a6.267,6.267,0,0,0-1.932,5.33c.254,1.408,2.35,2.892,1.061,4.187-.912.916,1.85,2.582,2.3,5.18a4.615,4.615,0,0,0,.12.558c-.04-1.329-.55-2.757-.518-4.048.066-2.65,4.062-2.837,6.016-3.013,2.6-.234,5.436-.211,7.687-1.731.915-.618,1.5,4.376,1.535,4.621a13.853,13.853,0,0,1,.257,4.382h.63c.182-1.684.015-3.3,1.253-4.522a12.76,12.76,0,0,0,1.67-1.888A6.621,6.621,0,0,0,2855.511,1107.22Z",
    transform: "translate(-2832.741 -1094.093)",
    fill: "#3a384d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6387",
    "data-name": "Path 6387",
    d: "M2820.863,1266.642a28.073,28.073,0,0,1-1.126,5.147c-.6,1.828-.16,4.376-.123,6.3.051,2.684,2.136,5.62,1.679,8.258-1.168-3.282-4.733-5.835-6.558-8.9-1.782-2.993-3.055-5.409-1.018-8.235C2814.98,1267.459,2820.89,1266.478,2820.863,1266.642Z",
    transform: "translate(-2792.485 -1237.202)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6388",
    "data-name": "Path 6388",
    d: "M2915.487,1279.212c.252,5.588-.844,6.723-1.732,12.369,1.194-3.816,3.882-5.819,6-9.221,2.086-3.353,2.762-7.532-.653-9.767-.234-.153-3.537-1.682-3.521-1.386C2915.62,1272.023,2915.378,1276.791,2915.487,1279.212Z",
    transform: "translate(-2876.328 -1240.971)",
    fill: "url(#linear-gradient-21)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_41",
    "data-name": "Mask Group 41",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5560",
    "data-name": "Group 5560",
    transform: "translate(564.088 355.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6352",
    "data-name": "Path 6352",
    d: "M2697.641,702.745c-1.977,0-4.028.252-4.8-2.13-1.457-4.486.991-11.192,5.005-13.634a13.578,13.578,0,0,1,4.449-1.484,6.964,6.964,0,0,1,5.013.425c1.508.811,2.971-.493,4.534.548a9.588,9.588,0,0,1,3.056,3.686,22.961,22.961,0,0,1,1.813,5.885,2.538,2.538,0,0,1-.433,2.434c-1.621,2.511-3.779,4.27-6.9,4.27Z",
    transform: "translate(-2680.359 -685.234)",
    fill: "#3a384d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6353",
    "data-name": "Path 6353",
    d: "M2638.613,741.612s.357.749-1.971,1.919c-1.3.652-3.824,1.617-4.157,4.434-.172,1.454-.74,5.045-2.124,5.267-3.446.553-8.1,2.7-8.531,6.885-.5,4.8.883,7.319,3.326,7.946,1.795.461,2.249.943,1.886,2.84-.348,1.819,1.032,8.347,4.042,10.01,6.746,3.727,12.623-13.254,12.623-13.254l1.381-21.924Z",
    transform: "translate(-2621.728 -731.998)",
    fill: "#3a384d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6354",
    "data-name": "Path 6354",
    d: "M2779.21,730.37s-.364.793,2.006,2.033c1.322.691,3.893,1.713,4.233,4.7.175,1.541.585,3.706,1.994,3.941,3.508.586,7.574,4,8.439,10.641.66,5.066-.781,10.5-3.269,11.163-1.827.488-1.689-.48-1.32,1.53.354,1.928-.477,1.184-3.542,2.945-6.868,3.949-13.727-9.354-13.727-9.354l-1.406-23.227Z",
    transform: "translate(-2746.886 -722.673)",
    fill: "#3a384d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6355",
    "data-name": "Path 6355",
    d: "M2737.206,870.617s5.213-1.343,6.321.318c.553,2.762.838,5.506.838,5.506l-6.007,1.128-3.973-.915-.945-.549-.392-3.913A15.1,15.1,0,0,1,2737.206,870.617Z",
    transform: "translate(-2714.064 -838.577)",
    fill: "#b97232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6356",
    "data-name": "Path 6356",
    d: "M2709.122,782.421s-.838-2.515-2.1-1.677,1.887,6.188,1.887,6.188Z",
    transform: "translate(-2692.233 -764.315)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6357",
    "data-name": "Path 6357",
    d: "M2794.494,780.17s0-3.772,2.1-1.677-2.1,5.03-2.1,5.03Z",
    transform: "translate(-2765.031 -762.064)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6358",
    "data-name": "Path 6358",
    d: "M2858.126,917.028c-1.755-8.47-4.274-15.09-5.07-15.473l-4.759,11.773a31,31,0,0,0-.883,7.864h7.318A3.464,3.464,0,0,0,2858.126,917.028Z",
    transform: "translate(-2808.923 -864.665)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6359",
    "data-name": "Path 6359",
    d: "M2654.682,933.751c.219-3.784.124-6.167.124-6.167L2648.1,916.7a94.9,94.9,0,0,0-1.677,12.14q-.058.614-.112,1.247a3.386,3.386,0,0,0,3.376,3.667Z",
    transform: "translate(-2642.109 -877.224)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6360",
    "data-name": "Path 6360",
    d: "M2735.921,856.386h7.3l1.98-20.815s-1.677-.432-2.515-3.366a59.51,59.51,0,0,1-1.258-8.808l-7.545,1.673s.838,7.987-.838,11.76Z",
    transform: "translate(-2714.064 -799.835)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6361",
    "data-name": "Path 6361",
    d: "M2706.671,952.932l1.051-13.139c-7.649,4.576-15.514,4.354-23.492,1.927l2.264,11.212Z",
    transform: "translate(-2673.57 -896.382)",
    fill: "#fc7886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6362",
    "data-name": "Path 6362",
    d: "M2674.514,905.324c-2.267-10.933-4.665-22.9-4.665-22.9l-1.257,2.508-11.736,3.363c.574,2.682,2.329,10.062,4.093,17.027Z",
    transform: "translate(-2650.865 -848.797)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6363",
    "data-name": "Path 6363",
    d: "M2790.357,899.212c.625-3.349,1.176-5.963,1.176-5.963l2.537-13.673c-.8-.8-13.329-2.517-13.329-2.517l-1.341-2s-1.673,12.163-3.1,24.155Z",
    transform: "translate(-2749.938 -842.685)",
    fill: "#fcb151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6364",
    "data-name": "Path 6364",
    d: "M2715.517,734.03s-.419,10.06.838,11.736,2.934,5.449,5.868,5.868,7.545-7.964,7.545-8.383-.419-11.317-.419-11.317S2720.547,724.808,2715.517,734.03Z",
    transform: "translate(-2699.467 -721.791)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6365",
    "data-name": "Path 6365",
    d: "M2704.707,723.459s-1.677,5.03,3.353,3.353l5.03-1.677s5.03-2.934,5.868-1.677a20.8,20.8,0,0,1,1.677,4.354s1.677-4.354,0-6.869S2708.48,716.334,2704.707,723.459Z",
    transform: "translate(-2690.334 -712.898)",
    fill: "#3a384d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5459",
    "data-name": "Group 5459",
    transform: "translate(-509.246 105.458)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3830",
    "data-name": "Path 3830",
    d: "M426.859,326.815c.326.917-6.1,12.132-7.2,13.033-1.088.9-9.876,1.555-10.109.218-.218-1.322,4.992-4.2,4.992-4.2l.981-5.77,6.018-7.388A64.569,64.569,0,0,1,426.859,326.815Z",
    transform: "translate(1334.95 186.081)",
    fill: "#758ca1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3831",
    "data-name": "Path 3831",
    d: "M374.351,332.024c1.867,3.842,3.018,6.423,2.816,6.749-.871,1.463-23.764,3.8-24.153,1.323-.39-2.489,11.275-7.248,11.275-7.248A14.843,14.843,0,0,0,374.351,332.024Z",
    transform: "translate(1318.23 188.835)",
    fill: "#758ca1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3832",
    "data-name": "Path 3832",
    d: "M323.541,258.32a50.035,50.035,0,1,1,2.349-7.652l-1.228,4.557C324.319,256.267,323.961,257.308,323.541,258.32Zm-7.433-18.556a39.59,39.59,0,1,0-39.582,39.6A39.587,39.587,0,0,0,316.107,239.765Z",
    transform: "translate(1280.668 146.608)",
    fill: "#bbc6d1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3833",
    "data-name": "Path 3833",
    d: "M351.31,245.043l6.127,1.228.311.062,2.893.591-1.509,9.347-3.25-.653-31.277-6.267c-.857-.342-1.836-.919-2.023-1.774-.28-1.353-3.811-2.395-5.288-2.674a2.806,2.806,0,0,0-.5-.078c-.777-.047-2.427.575-1.259,2.721l-14.263-2.923c.42-1.012.779-2.054,1.121-3.1.42-1.322.793-2.676,1.1-4.028.047-.171.078-.358.124-.529l.389-1.43,32.8,6.594h.016Z",
    transform: "translate(1302.935 160.305)",
    fill: "#bbc6d1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3834",
    "data-name": "Path 3834",
    d: "M375.577,287.93s15.662-8.274,19.551-18.492c-3.531,14.573-18.68,30.172-18.68,30.172-.575-6.345-.855-11.633-.855-11.633Z",
    transform: "translate(1324.907 170.329)",
    fill: "#13258d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    "data-name": "Path 3835",
    d: "M456.646,263.333l-3.686,15.74-44.59-9.658-3.375-.731-39.722-8.6-19.535-4.23.249-1.587.141.031,1.4-9.378h-.031l.389-2.457c.078-.047.14-.093.218-.14l9.565,1.85,37.3,7.217,3.98.777,29.131,5.63.078.016.513.109c1.135.28,3.344.98,4.324,2.691,1.369,2.332-1.368,7.7-.062,7.387,6.844-1.6,6.486-6.438,6.222-8.055Z",
    transform: "translate(1316.083 162.31)",
    fill: "#758ca1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3836",
    "data-name": "Path 3836",
    d: "M431.385,339l-6.019,7.388-.779.544c-.871.2-41.712-21.183-44.715-26.145-1.695-2.785-2.892-12.567-3.624-20.639,0,0,15.149-15.6,18.68-30.172a13.2,13.2,0,0,0,.684-2.365v.109c2.037,23.422-3.686,34.015-.575,41.013C397.433,314.133,420.7,331.1,431.385,339Z",
    transform: "translate(1325.104 169.789)",
    fill: "#3b55eb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3837",
    "data-name": "Path 3837",
    d: "M420.386,257.594c.264,1.617.622,6.454-6.222,8.055-1.306.311,1.432-5.055.062-7.387-.979-1.712-3.189-2.411-4.324-2.691l-.513-.109-.078-.016c-.078-.031-.124-.031-.124-.047,0-.078,1.306-1.726,1.306-1.726l1.276-.7,4.852-2.69.047-.016c2.177,4.137,3.624,6.92,3.624,6.92S420.324,257.328,420.386,257.594Z",
    transform: "translate(1334.844 164.66)",
    fill: "#f8e8ab"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3838",
    "data-name": "Path 3838",
    d: "M434.1,260.118l-.047.016-4.852,2.69s-19.318-26.922-22.381-28.9c-3.08-1.976-29.458-7.559-31.651-5.474-1.368,1.306,9.129,15.8,18.462,30.437l-37.3-7.217c-1.306-3-2.41-5.723-3.1-7.87-.42-1.446-.824-2.908-1.2-4.4-1.461-6.019-2.317-12.318-1.415-17.886,0,0,1.648.824,9.814-4.091a41.162,41.162,0,0,1,11.4-.124c6.874.84,38.182,5.257,41.93,8.041C416.521,227.378,428.091,248.8,434.1,260.118Z",
    transform: "translate(1317.417 154.81)",
    fill: "#536dfe"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3839",
    "data-name": "Path 3839",
    d: "M423.539,260.3l-1.276.7s-15.179-20.872-20.731-24.574-18.181-6.7-28-7.186c0,0,10.048,14.216,18.414,27.9l-3.98-.777c-9.333-14.636-19.831-29.131-18.462-30.437,2.194-2.085,28.572,3.5,31.651,5.474C404.221,233.383,423.539,260.3,423.539,260.3Z",
    transform: "translate(1323.075 157.329)",
    fill: "#3b55eb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3840",
    "data-name": "Path 3840",
    d: "M396.556,269.169l-2.4-.047a46.98,46.98,0,0,0-2.69-6.454l3.375.731A18.226,18.226,0,0,1,396.556,269.169Z",
    transform: "translate(1329.605 168.327)",
    fill: "#3b55eb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3841",
    "data-name": "Path 3841",
    d: "M403.225,271.085l-3.047-.047-27.872-.513-2.892-.047-1.12-.015s-3.5-6.5-7.481-14.433l39.722,8.6A46.98,46.98,0,0,1,403.225,271.085Z",
    transform: "translate(1320.541 166.364)",
    fill: "#536dfe"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3842",
    "data-name": "Path 3842",
    d: "M378.37,267.228l27.872.513a13.192,13.192,0,0,1-.684,2.365c-3.888,10.218-19.551,18.492-19.551,18.492-6.8,3.686-26.673,14.713-27.871,18.415-1.135,3.469,13.609,31.122,19.969,44.186a14.844,14.844,0,0,1-10.062.824s-27.093-37.591-27.731-47.561c-.637-9.72,33.314-35.849,35.165-37.28Z",
    transform: "translate(1314.476 169.661)",
    fill: "#3b55eb"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3843",
    "data-name": "Path 3843",
    d: "M356.961,213.232a29.867,29.867,0,0,1,2.954,3.033,4.52,4.52,0,0,0,.171.591c1.043,2.722,1.7,4.137,2.722,4.137-8.165,4.915-9.814,4.091-9.814,4.091l-.093.14s.093-1.99-2.194-5.3c-.047.016-4.713.637-5.443.3-.7-.327-2.753-8.9-3.033-14.6.53-.109,6.237-1.338,7.388-.327,1.2,1.073.746,5.35,2.271,5.086,1.524-.249.513-1.976.871-2.3a2.017,2.017,0,0,1,2.5,1.525,5.791,5.791,0,0,1,.187,2.3l.155.031s.156.155.421.4c.124.124.28.264.435.42C356.618,212.89,356.79,213.046,356.961,213.232Z",
    transform: "translate(1315.044 151.241)",
    fill: "#f8e8ab"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3844",
    "data-name": "Path 3844",
    d: "M359.438,202.24c1.883,4.137.342,12.3,1,15.552a29.883,29.883,0,0,0-2.954-3.033c-.171-.187-.342-.342-.5-.482-.171-.171-.311-.311-.435-.42-.266-.249-.421-.4-.421-.4l-.156-.031a5.789,5.789,0,0,0-.187-2.3,2.017,2.017,0,0,0-2.5-1.525c-.358.327.653,2.054-.871,2.3-1.525.264-1.074-4.013-2.271-5.086-1.151-1.012-6.858.218-7.388.326a.048.048,0,0,1-.031.016s-1.8-.871-2.239-3.935c0,0,5.226-1.166,8.072-2.007S357.432,197.839,359.438,202.24Z",
    transform: "translate(1314.529 149.714)",
    fill: "#758ca1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3845",
    "data-name": "Path 3845",
    d: "M355.1,234.279c.373,1.494.777,2.955,1.2,4.4a26.458,26.458,0,0,1-6.469,6.02l-.187-.031-.031.171a28.388,28.388,0,0,1-3.282,1.866l-.311-.062-6.127-1.228C346.982,242.973,355.1,234.279,355.1,234.279Z",
    transform: "translate(1314.353 159.932)",
    fill: "#3b55eb"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3846",
    "data-name": "Path 3846",
    d: "M356.9,220.615l.093-.14c-.9,5.568-.047,11.867,1.415,17.886,0,0-8.119,8.694-15.21,11.137l-14.481-2.909c5.165-.933,11.665-2.427,14.077-4.495C346.975,238.5,353.491,229.356,356.9,220.615Z",
    transform: "translate(1311.049 155.85)",
    fill: "#536dfe"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3847",
    "data-name": "Path 3847",
    d: "M321.443,247.232a8.448,8.448,0,0,0,1.322.4s-6.642,2.394-9.425-.84a7.294,7.294,0,0,1-.964-1.37c-1.168-2.146.482-2.768,1.259-2.721a2.8,2.8,0,0,1,.5.078c1.477.28,5.008,1.322,5.288,2.674C319.607,246.314,320.586,246.89,321.443,247.232Z",
    transform: "translate(1306.097 162.423)",
    fill: "#f8e8ab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3848",
    "data-name": "Path 3848",
    d: "M310.338,236.658a36.928,36.928,0,1,0-36.921,36.937A36.925,36.925,0,0,0,310.338,236.658Z",
    transform: "translate(1283.78 149.714)",
    fill: "#a5b7c6",
    style: {
      mixBlendMode: "hard-light",
      isolation: "isolate"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerDataEmpty);
export default __webpack_public_path__ + "static/media/customer-data-empty.e7c4ccf6.svg";
export { ForwardRef as ReactComponent };